import axiosClient from "../../../../../system/helpers/axiosConfig";

export const getFAQ = (params) => {
  return axiosClient.get(`/api/faqs`, { params }).then((r) => r.data);
};
